import Vue from "vue";
import Vuex from "vuex";

//import modules
import globalSettings from "./modules/globalSettings";
import notifications from "./modules/notifications";
import settingsSlider from "./modules/settingsSlider";
import userDetails from "./modules/userDetails";
import urls from "./modules/urls";

Vue.use(Vuex);

const store = new Vuex.Store({
    state: {},
    modules: {
        globalSettings,
        notifications,
        settingsSlider,
        userDetails,
        urls
    },
    actions: {
        resetAllModules(context) {
            context.commit("globalSettings/resetState");
            context.commit("settingsSlider/resetState");
            context.commit("urls/resetState");
        }
    },
    mutations: {},
    getters: {},
    strict: true
});

export default store;
